import { RefString, RefNumber } from "@tblabs/truffle";
import { RawHuman } from "./RawHuman";
import { TextFormatter } from "../Utils/TextFormatter";


export class Human
{
    public Id = "";
    public Type = new RefString("Klient");
    public Name = new RefString();
    public Address = new RefString();
    public Email = new RefString();
    public Phone = new RefString();
    public Experience = new RefNumber(0);
    public Description = new RefString();
    public BankAccountNumber = new RefString();
    public Origin = new RefString();

    public get AsString(): string
    {
        return `${this.ExperienceIcon} ${this.Name.value || "---"} (${this.Type.value || "---"})
☎️ ${TextFormatter.NicePhoneNumber(this.Phone.value) || "---"}
📌 ${this.Address.value || "---"}
📧 ${this.Email.value || "---"}
🧭 ${this.Origin.value || "---"}`
        + (this.Description.value.length ? `\n(${this.Description.value})` : "");
    }

    public get AsShortString(): string
    {
        return `${this.ExperienceIcon} ${this.Name.value || "---"}`;
    }

    public get ExperienceIcon(): string
    {
        const expIcon = { 0: "👨‍💼", 1: "🥔", 2: "🥉", 3: "🥈", 4: "🥇" };
        const exp = expIcon[this.Experience.value] || "👨‍💼";
        return exp;
    }

    constructor(raw: Partial<RawHuman>)
    {
        this.Id = raw.Id || "";
        this.Type.value = raw.Type || "";
        this.Name.value = raw.Name || "";
        this.Phone.value = raw.Phone || "";
        this.Email.value = raw.Email || "";
        this.Address.value = raw.Address || "";
        this.Description.value = raw.Description || "";
        this.Experience.value = raw.Experience || 0;
        this.BankAccountNumber.value = raw.BankAccountNumber || "";
        if (this.BankAccountNumber.value == "(brak numeru konta)") // LEGACY
        {
            this.BankAccountNumber.value = "";
        }
        this.Origin.value = raw.Origin || "";
    }

    public static get Default(): Human
    {
        return new Human({
            Type: "Klient",
            Experience: 0,
            Name: "---",
            Phone: "---",
            Address: "---",
            Email: "---",
            BankAccountNumber: "---",
            Origin: "---",
        });
    }
}
